import React from 'react'

function DefaultSlideSkeleton() {
  return (
    <div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-secondaryColour transition-colors duration-200">
      <div className="skeleton"></div>
    </div>
  )
}

export default DefaultSlideSkeleton
